import * as _ from 'underscore';
import { Templates } from '../../../compile/templates';
import React from 'react';
import ReactDOM from 'react-dom';
import { BaseUIElement } from './baseUIElement';

export class ReactContainer extends BaseUIElement {
	private element: KnockoutObservable<HTMLElement>;

	constructor(id: string, label: string, component: React.Component, props?: any, children?: any) {
		super(id, label, {
			template: Templates.layouts_empty_div
		});

		this.element = ko.observable();
		this.element.subscribe((e) => {
			ReactDOM.render(React.createElement(component, props, children), e)
        })
    }
}
